import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import CustomDialog from 'shared/components/custom-dialog/CustomDialog';

class SetHead extends React.Component {

  handleDeleteDialogeBox = (event, text) => {
    let { handleDeleteSet, setIndex } = this.props;
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomDialog
            title="Are you sure"
            text="you want to delete this set?"
            cancelText="No"
            confirmText="Yes"
            onClose={onClose}
            handleConfirming={() => {
              handleDeleteSet(setIndex);
            }}
          />
        );
      }
    });
  };

  render() {
    let { title, showDeleteIcon } = this.props;
    return (
      <h3>
        <span>{title}</span>
        { showDeleteIcon && (
            <div className="link-cursor-style" onClick={e => this.handleDeleteDialogeBox()}>
              <i className="fas fa-trash"></i>
            </div>
          )
        }
      </h3>
    );
  }
}

export default SetHead;
